import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import React, { useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { Gap } from "../../atoms";
import { Grid,Paper } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Table from "./table";
import { getDaftarAnggota } from "../../../config/Redux/DaftarAnggota/actions";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@mui/styles";
import { PRIMARY } from "../../../utils/constansColors";
import SearchIcon from "@mui/icons-material/Search";

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: PRIMARY,
      color: "white",
      border: "none",
    },
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    fontSize: "25px",
    borderRadius: 5,
  },
  tableHeader: {
    backgroundColor: "transparant",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    color: "#757575",
    fontWeight: 700,
  },
});

const DaftarAnggota = () => {
	const classes = useStyles();
  const dispatch = useDispatch();
  let params = useParams();
  // const { state } = useLocation();
	const [loading, setLoading] = useState(false);
	const [cari, setSearch] = useState('');
	const [toggle, setToggle] = useState('desc');
	const [orderBy, setOrderBy] = useState('created_at');
	const [currentPage, setCurrentPage] = useState(1);
	const [selectMarriage, setSelectMarriage] = useState('');
	const [selectGender, setSelectGender] = useState('');
	const [optionOrderBy, setOptionOrder] = useState([
		{
			id:"created_at",
			label:"Waktu Pendaftaran"
		},
		{
			id:"name",
			label:"Nama"
		},
		// {
		// 	id:"nik",
		// 	label:"NIK"
		// },
		{
			id:"no_kta",
			label:"No KTA"
		},
		// {
		// 	id:"tgl_lahir",
		// 	label:"Tanggal Lahir"
		// }
	]);
	const dataAnggota = useSelector((state) => state.daftarAnggota.dataDaftarAnggota);
	// console.log(dataAnggota)

	const updateData = async (order_type,order_by,page,size,search,jenis_kelamin,status_perkawinan) =>{
		setLoading(true)
		let wait = await dispatch(getDaftarAnggota(order_type,order_by,page,size,search,params?.tingkatExcoId,params?.idDaerah,jenis_kelamin,status_perkawinan));  
		if(wait){
			setLoading(false)
		}
	}
  useEffect(() => {
		updateData('desc','created_at',1,10,'','','')
  }, [dispatch, params?.tingkatExcoId]);
	
	const handleSort = (event) => {
    setOrderBy(event.target.value)
		updateData(toggle,event.target.value,currentPage,10,cari,selectGender,selectMarriage)
  }
  const handleSortType = (value) => {
    setToggle(value)
		updateData(value,orderBy,currentPage,10,cari,selectGender,selectMarriage)
  }
	const handleSelectMarriage = (event) => {
    setSelectMarriage(event.target.value)
		updateData(toggle,orderBy,currentPage,10,cari,selectGender,event.target.value)
  }
	const handleSelectGender = (event) => {
    setSelectGender(event.target.value)
		updateData(toggle,orderBy,currentPage,10,cari,event.target.value,selectMarriage)
  }

	const handlePagination = (event, value) => {
    setCurrentPage(value);
    updateData(toggle,orderBy,value,10,cari,selectGender,selectMarriage)
  };

	const handleSearch = (event) => {
    setSearch(event.target.value)
    let temp = event.target.value
    var timeout;
    var delay = 500;
    if(timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(function() {
      if(temp === event.target.value){
        updateData(toggle,orderBy,currentPage,10,event.target.value,selectGender,selectMarriage)
        setCurrentPage(1);
      }
    }, delay);
  }

  const breadcrumbs = [
		(params?.tingkatExcoId === "1")?
		(<Link
      to={"/"}
      style={{ textDecoration: "none", fontWeight: "bold", color: "black", fontSize:'14px' }}
    >
      EXCO Pusat
    </Link>)
		: (params?.tingkatExcoId === "2")?
		(<Link
      to={"/provinsi"}
      style={{ textDecoration: "none", fontWeight: "bold", color: "black", fontSize:'14px' }}
    >
      EXCO Provinsi
    </Link>)
		: (params?.tingkatExcoId === "3")?
		(<Link
      to={"/kab-kot"}
      style={{ textDecoration: "none", fontWeight: "bold", color: "black", fontSize:'14px' }}
    >
      EXCO Kab/Kota
    </Link>)
		: (params?.tingkatExcoId === "4")?
		(<Link
      to={"/kecamatan"}
      style={{ textDecoration: "none", fontWeight: "bold", color: "black", fontSize:'14px' }}
    >
      EXCO Kecamatan
    </Link>)
		: (params?.tingkatExcoId === "5")?
		(<Link
      to={"/kelurahan"}
      style={{ textDecoration: "none", fontWeight: "bold", color: "black", fontSize:'14px' }}
    >
      EXCO Kelurahan
    </Link>)
		:""
		,
		<Typography key="2" color="text.primary" style={{ color: "#BDBDBD", fontSize:'14px', marginTop:'2px' }}>
			{params?.namaDaerah}
		</Typography>
  ];

  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
			{(loading)?
			<div style={{position:'fixed', width:"100%", height:"100%", left:"0", top:'0', zIndex:'10000', backgroundColor:'rgba(0,0,0,0.7'}}>
				<div style={{textAlign:'center', paddingTop:'17%'}}>
					<div className="loader"></div>
					<h2 style={{color:'lightgray'}}>Sedang memuat data ...</h2>
				</div>
			</div>
			:null}
			<div className="overview-detail-header">
				<Gap height={40} />
				<Breadcrumbs separator="›" aria-label="breadcrumb">
					{breadcrumbs}
				</Breadcrumbs>
				<Grid container spacing={0}>
					<Grid item xs={12} sm={8} md={6}>
						<p style={{ fontSize: 24, fontWeight: 'bold', margin:"8px 0px" }}>
							Daftar Anggota ({dataAnggota?.data?.total_items?.toLocaleString().replace(/,/g,".",)})
						</p>
					</Grid>
					{/* <Grid item xs={12} sm={4} md={6}>
						<div className="overview-filter-group">
							<span>Saring Status Perkawinan</span><br/>
							<select className="overview-filter-select" onChange={handleSelectMarriage}>
								<option value="">Semua</option>
								<option value="0">Belum Kawin</option>
								<option value="1">Sudah Kawin</option>
								<option value="2">Pernah Kawin</option>
							</select>
						</div>
						<div className="overview-filter-group">
							<span>Saring Jenis Kelamin</span><br/>
							<select className="overview-filter-select" onChange={handleSelectGender}>
								<option value="">Semua</option>
								<option value="L">Laki-laki</option>
								<option value="P">Perempuan</option>
							</select>
						</div>
					</Grid> */}
				</Grid>
			</div>
			<Gap height={110} />
			{/* <Gap height={20} />
      <Paper className="overview-paper-secondary">
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<h3 className="overview-header">Pengurus</h3>
					</Grid>
				</Grid>
				<Grid container spacing={2}>
					<Grid item xs={6} sm={4} md={4}>
						<div className="overview-paper-card">
							<p className="overview-main-value">85.947</p>
							<p className="overview-title-value">Total Pengurus</p>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={4}>
						<div className="overview-paper-card">
							<p className="overview-main-value">4059 <span className="overview-secondary-value">(28%)</span></p>
							<p className="overview-title-value">Total Pengurus Perempuan</p>
						</div>
					</Grid>
					<Grid item xs={12} sm={4} md={4}>
						<div className="overview-paper-card">
							<p className="overview-main-value">4050 <span className="overview-secondary-value">/5676</span></p>
							<p className="overview-title-value">Jumlah Organisasi Kepengurusan</p>
						</div>
					</Grid>
					<Grid item sm={12} md={12}>
						<span className="overview-note">*Organisasi Kepengurusan = EXCO Pusat + EXCO Provinsi + Exco Kab/Kota + Exco Kecamatan (yang memiliki pengurus)</span>
					</Grid>
				</Grid>
			</Paper> */}
			<Gap height={20} />
			<Paper className="overview-paper-secondary">
				<div className="overview-filter">
					<div style={{display:'inline-block', marginRight:'8px'}}>
						<div style={{position:'absolute', color:'#757575', marginTop:'6px', marginLeft:'6px'}}><SearchIcon /></div>
						<input
							id="search"
							name="search"
							value={cari}
							onChange={handleSearch}
							placeholder="Cari"
							style={{
								paddingLeft:'24px',
								borderRadius: 6,
								backgroundColor: "white",
								height: 22,
								fontSize:'12px',
								margin: '4px',
								border: '2px solid #757575'
							}}
						/>
					</div>
					<span style={{fontSize:'14px', fontWeight:'bold'}}>Pengurutan</span>
					<select className="overview-filter-select" onChange={handleSort}>
						{optionOrderBy.map((option, index)=>{
							return(
							<option value={option.id} key={index}>{option.label}</option>
							)
						})}
					</select>
					<div className="overview-toggle">
						<div className={(toggle==="asc")?"active":""} onClick={() => handleSortType('asc')}>Asc</div>
						<div className={(toggle==="desc")?"active":""} onClick={() => handleSortType('desc')}>Desc</div>
					</div>
				</div>
				<Table/>
				<div
					style={{
						justifyContent: "flex-end",
						display: "flex",
						marginTop: "10px",
					}}
				>
					<Pagination
						count={Math.ceil(dataAnggota?.data?.total_items/10)}
						variant="outlined"
						shape="rounded"
						page={currentPage}
						onChange={handlePagination}
						className={classes.root}
					/>
				</div>
			</Paper>
      <Gap height={10} />
      <div className="footer-content"></div>
    </div>
  );
};

export default DaftarAnggota;
